<template>
  <Teleport to="body">
    <Transition
      name="save-toast"
      enter-active-class="save-toast-enter-active"
      leave-active-class="save-toast-leave-active"
      enter-from-class="save-toast-enter-from"
      leave-to-class="save-toast-leave-to"
    >
      <div
        v-if="showSaveToast"
        class="save-toast"
        :class="saveStatus.class"
        :style="{ zIndex: 1000000 }"
        role="alert"
        aria-live="polite"
      >
        <div class="save-toast-icon">
          <div v-if="saveStatus.type === 'saving'" class="loading-spinner"></div>
          <svg
            v-else-if="saveStatus.type === 'saved'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <svg
            v-else-if="saveStatus.type === 'error'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
          <!-- warning 아이콘: 삼각형 경고 (공유 KPI 수정 불가 등) -->
          <svg
            v-else-if="saveStatus.type === 'warning'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <!-- info 아이콘: 원형 정보 -->
          <svg
            v-else-if="saveStatus.type === 'info'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </div>
        <div class="save-toast-content">
          <div class="save-toast-message">{{ saveStatus.message }}</div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useUiToast } from '~/composables/useUiToast';

const { showSaveToast, saveStatus } = useUiToast();
</script>

<style lang="scss" scoped>
// Toast 방식 저장 상태 표시
.save-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  /* UiFilterModal 오버레이(10050)·드롭다운(10051)보다 위 — 보드 업무 메뉴 등에서 showAlert 토스트가 마스크에 가리지 않도록 */
  z-index: 10100;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 300px;
  max-width: 400px;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;

  &--saving {
    border-left: 4px solid #f59e0b;

    .save-toast-icon {
      color: #f59e0b;
    }
  }

  &--saved {
    border-left: 4px solid #10b981;

    .save-toast-icon {
      color: #10b981;
    }
  }

  &--error {
    border-left: 4px solid #ef4444;

    .save-toast-icon {
      color: #ef4444;
    }
  }

  /* 경고 토스트 (공유 KPI 수정 불가 등) */
  &--warning {
    border-left: 4px solid #f59e0b;

    .save-toast-icon {
      color: #f59e0b;
    }
  }

  &--info {
    border-left: 4px solid #3b82f6;

    .save-toast-icon {
      color: #3b82f6;
    }
  }

  .save-toast-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .loading-spinner {
      width: 20px;
      height: 20px;
      border: 2px solid transparent;
      border-top: 2px solid currentColor;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .save-toast-content {
    flex: 1;
    min-width: 0;

    .save-toast-message {
      font-size: 14px;
      font-weight: 500;
      color: #374151;
      line-height: 1.4;
      white-space: pre-line;
    }
  }
}

// Toast 애니메이션 (상단 중앙용)
.save-toast-enter-active,
.save-toast-leave-active {
  transition: all 0.3s ease;
}

.save-toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px) scale(0.95);
}

.save-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px) scale(0.95);
}

// 애니메이션
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
